import React from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material'
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

import "./certificate.css"
import { useCookies } from 'react-cookie';

function Certificate({ open, setOpen, internshipName, enrollDate, submissionDate }) {
    const [cookies] = useCookies();

    const handleClose = () => {
        setOpen(false)
    }

    const downloadFunction = () => {
        html2canvas(document.querySelector("#capture")).then(canvas => {
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF({
                orientation: "landscape",
                unit: "in",
                format: [8.5, 5.5]
            });
            pdf.addImage(imgData, 'PNG', 0, 0);
            pdf.save("certificate-101.pdf");
            handleClose();
        });
    }

    return (
        <Dialog
            id="certificate"
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogContent>
                <CertificateDesign />
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' color="error" onClick={handleClose}>cancel</Button>
                <Button id="download-button" onClick={downloadFunction}>Download</Button>
            </DialogActions>
        </Dialog>
    )

    function CertificateDesign() {
        return (
            <Stack direction="row"
                justifyContent="center"
                alignItems="center"
                id="capture"
            >
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    sx={{ bgcolor: "white", width: 706, height: 418 }}
                >
                    <Typography sx={{ fontWeight: 700, fontSize: "35px", fontFamily: "Montserrat" }}>CERTIFICATE OF INTERNSHIP</Typography>
                    <Typography sx={{ fontFamily: "Montserrat" }}>THIS CERITIFICATE PROUDLY PRESENTED TO</Typography>
                    <Typography id="user-name">{cookies.firstName} {cookies.lastName}</Typography>
                    <Typography id="description">has successfully completed <span style={{ fontWeight: 600 }}>{internshipName}</span>{" "}
                        live project from Xpverse Pvt. Ltd. from <span style={{ fontWeight: 600 }}>{getFormatedDate(enrollDate)} to {getFormatedDate(submissionDate)}.</span>{" "}
                        During this internship, the student was found to be a keen and enthusiastic Candidate.
                    </Typography>

                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{
                            width: "77%"
                        }}
                    >
                        <Box sx={{ textAlign: "center" }}>
                            <Typography>Kumar</Typography>
                            <Typography sx={{ fontWeight: 600 }}>CEO</Typography>
                        </Box>
                        <Box sx={{ textAlign: "center" }}>
                            <Typography>David Miller</Typography>
                            <Typography sx={{ fontWeight: 600 }}>Program Manager</Typography>
                        </Box>
                    </Stack>
                </Stack>
            </Stack >
        );
    }

    function getFormatedDate(rawDate) {
        var options = {
            day: "numeric",
            year: "numeric",
            month: "long",
        };
        var fomatedDate = new Date(rawDate).toLocaleDateString("en-US", options);
        // 10 Aug, 2021
        return fomatedDate;
    }

}

export default Certificate
